import {FC, useMemo, useState} from "react"

import {CauseOnMessageWithCauseAndPart} from "@ri2/db/client"

import {Cause} from "./causes/cause"
import {generateIconBackgrounds} from "./causes/utils"

interface Props {
  cause: CauseOnMessageWithCauseAndPart
  caseId: string
}

export const InlineConfirmedCauseCard: FC<Props> = ({cause, caseId}) => {
  const [, setHoveredItem] = useState<number | null>(null)
  const iconBackground = useMemo(() => generateIconBackgrounds(1)[0], [])

  return (
    <Cause
      caseId={caseId}
      cause={cause}
      bucket="confirmed"
      setHoveredItem={setHoveredItem}
      isHighlighted
      iconBackground={iconBackground}
      isInConversation
    />
  )
}
